import { useEffect } from 'react';
import './Chatbot.css'

const intro = `I'm Spidy, an assistant that helps Yassine build and organize his portfolio. I know the details of his projects 
and experiences and act as a co-worker who understands the framework while also answering general questions with AI capabilities.`

const questions_samples = [
    "How many projects has Yassine worked on?",
    "How much has Yassine contributed to the NeuroDrive project?",
    "How many tasks has Yassine completed for the Clarix system?",
    "How does Yassine operate PulseX and how much has he developed it?",
    "How much has Yassine contributed to the Asclepius project?",
    "How much experience does Yassine have with machine learning?",
    "How many programming languages does Yassine use?",
    "What is Yassine's educational background?",
    "How much experience does Yassine have with embedded systems?",
    "How many web development skills has Yassine mastered?",
    "How many healthcare-related AI projects has Yassine worked on?",
    "How much focus does Yassine have in his Master's program?",
    "How much work has Yassine done on Dermalyze?",
    "How much experience does Yassine have with Raspberry Pi?",
    "How long has Yassine been working with AI?",
    "Which tools does Yassine use for data visualization?",
    "How strong is Yassine's background in mathematics and computer science?",
    "How many full-stack applications has Yassine built?",
    "How much remote work experience does Yassine have?",
    "What are the main areas of interest that Yassine focuses on in AI?",
    "How many AI models has Yassine trained or fine-tuned?",
    "How much research has Yassine done in intelligent automation?",
    "How many embedded systems projects has Yassine completed?",
    "How many datasets has Yassine worked with for machine learning?",
    "How many predictive models has Yassine built?"
];

const unavailability_stats = [
    "🚧 Oops! I'm not deployed yet. Currently homeless in the cloud and still looking for a proper server to call home. Please try again later.",
    "🌐 Not live yet! I'm still floating around the internet waiting for my official hosting spot. Give me a little time and try again soon.",
    "🏗️ Deployment in progress. I'm still setting up my digital office space. Please check back later once I've settled in.",
    "⚠️ Service not available yet. I'm currently between servers and awaiting deployment. Please try again later.",
    "🕸️ I'm not hosted yet! Still wandering the internet looking for a home Try again later."
]

const Chatbot = ({ onClose, isVisible }) => {
    useEffect(() => {
        const user_input = document.querySelector('.user-input');
        if (user_input) {
            GeneratePlaceHolders(questions_samples, user_input);
        }
    }, []);

    return (
        <div className={`chatbot-container ${isVisible ? 'visible' : 'hidden'}`}>
            <div className='chatbot-head-container'>
                <i 
                    onClick={() => CreateMessage('bot', intro)}
                    className='fa fa-info info-icon'
                ></i>
                <i 
                    onClick={onClose}
                    className='fa fa-times close-icon'
                ></i>
            </div>
            <div className='messages-container'>
                <span className='message bot-message'>Hello, I am Spidy! 🕷️ How can i assist you?</span>
            </div>
            <div className='bot-input-container'>
                <input 
                    onKeyDown={(e) => {if (e.key === "Enter") {Send();}}}
                    className='user-input'
                    placeholder='Type your message...'
                />
                <button 
                    onClick={() => Send()}
                    className='bot-send-button'
                ><i className='fa fa-paper-plane'></i></button>
            </div>
        </div>
    )
}

export default Chatbot;

async function Send() {
    const user_input = document.querySelector('.user-input');
    const question = user_input.value.trim();
    if (!question) return;

    CreateMessage('user', question);
    user_input.value = '';

    let wakingMessage = null;
    
    const wakeTimeout = setTimeout(() => {
        wakingMessage = CreateMessage('bot', "(Waking up Spidy… 😴, He's quite lazy so this may take up to 50 seconds or more.");
    }, 5000);

    try {
        const response = await fetch('https://YOUR-RENDER-URL.onrender.com/spidy', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ question })
        });

        clearTimeout(wakeTimeout);
        if (wakingMessage) {
            wakingMessage.remove();
        }

        const data = await response.json();
        const bot_content = data.answer || "Wow, damn very hard question! Unfortunatly my web didn't get an answer! 🙄";
        CreateMessage('bot', bot_content);
    } catch (err) {
        clearTimeout(wakeTimeout);
        if (wakingMessage) {
            wakingMessage.remove();
        }
        CreateMessage('bot', unavailability_stats[Math.floor(Math.random() * unavailability_stats.length)]);
    }
}

function CreateMessage(owner, content) {
    const messages_container = document.querySelector('.messages-container')
    const message = document.createElement('span');
    message.textContent = content;
    owner === 'user' ? message.classList.add('message', 'user-message') : message.classList.add('message', 'bot-message');
    messages_container.appendChild(message);
    messages_container.scrollTop = messages_container.scrollHeight;
    return message;
}

let currentTypingTimeouts = [];

function GeneratePlaceHolders(samples, location) {
    let samples_index = 0;

    function startTyping() {
        location.placeholder = "";
        SlowTyping(samples[samples_index].split(""), location);
        samples_index = (samples_index + 1) % samples.length;
    }

    startTyping();

    setInterval(() => {
        currentTypingTimeouts.forEach(timeout => clearTimeout(timeout));
        currentTypingTimeouts = [];
        startTyping();
    }, 7000);
}

function SlowTyping(samples_letters, location) {
    currentTypingTimeouts.forEach(timeout => clearTimeout(timeout));
    currentTypingTimeouts = [];

    samples_letters.forEach((letter, index) => {
        const timeout = setTimeout(() => {
            location.placeholder += letter;
        }, 40 * index);
        currentTypingTimeouts.push(timeout);
    });
}